import React from "react";
import Breadcrumbs from "../components/Breadcrums"; // Assuming Breadcrumbs is used for navigation
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { PropertySurroundingsData } from "../configs";

const breadcrumbItems = [
  { label: "Home", path: "/" },
  { label: "Property Surroundings", path: "/property-surroundings" },
];

function PropertySurroundings() {
  return (
    <div className="flex flex-col justify-center lg:p-3">
      <Breadcrumbs items={breadcrumbItems} />

      <div className="flex flex-col gap-1 mb-3">
        {PropertySurroundingsData.map((category, categoryIndex) => (
          <div
            key={categoryIndex}
            className="flex flex-auto flex-col p-5 bg-secondary-medium rounded-lg hover:shadow-xl"
          >
            <h2 className="text-lg font-bold text-primary-main">
              {category.title}
            </h2>
            <div className="flex flex-wrap text-sm text-primary-main mt-2">
              {category.items.map((item, index) => (
                <div key={index} className="flex flex-row gap-1 py-1 px-2">
                  <FiberManualRecordIcon fontSize="small" />
                  {item}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default PropertySurroundings;
